<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Lsn391/tc-custom/9781627982610.jpg?1685327060534" alt="This image is the cover for the book Inside Out, Bronco's Boys"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Inside Out, Bronco's Boys
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Bronco's Boys: Book One</i></b></p><p>Former mercenary Bull Krebbs now heads up security at his nightclub in Harrisburg, PA. Working the door night after night, he's seen it all. Though tough on the outside, he's a little hurt that people find him unapproachable. Then he pulls a cute twink out of line to perform a random search, and he's surprised when the guy giggles and squirms.</p> <p>Zach Spencer, graphic artist, twink, and seriously ticklish, isn't intimidated by Bull. He's in awe, and when Bull saves Zach from being trampled on the dance floor, Zach finds his inspiration for the superhero in his graphic novel.</p> <p>Soon Zach wants more and makes his move by asking Bull on a date. Though small, he has a backbone of steel. He'll need it—their happily ever after is thwarted at every turn, including by Bull's interloping mother showing up unannounced and enemies from Bull's past threatening to pull him to the other side of the world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Grey
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?92770ea8